const GRADE_LEVELS = ['K-2', '3-5', '6-8', '9-12', 'College/Adult'];
const SUBJECTS = [
  'English Literature',
  'History / Social Studies',
  'Science',
  'Social-Emotional Learning',
  'Foreign Language',
  'General / Mixed',
];

interface MetadataFormProps {
  title: string;
  onTitleChange: (value: string) => void;
  author: string;
  onAuthorChange: (value: string) => void;
  gradeLevel: string;
  onGradeLevelChange: (value: string) => void;
  subject: string;
  onSubjectChange: (value: string) => void;
  wordCount: number;
  onWordCountChange: (value: number) => void;
}

export default function MetadataForm({
  title,
  onTitleChange,
  author,
  onAuthorChange,
  gradeLevel,
  onGradeLevelChange,
  subject,
  onSubjectChange,
  wordCount,
  onWordCountChange,
}: MetadataFormProps) {
  return (
    <div className="form-grid">
      <div className="form-group">
        <label htmlFor="title">Title</label>
        <input
          id="title"
          type="text"
          value={title}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) => onTitleChange(e.target.value)}
          className="form-input"
          placeholder="The Giver"
        />
      </div>

      <div className="form-group">
        <label htmlFor="author">Author</label>
        <input
          id="author"
          type="text"
          value={author}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) => onAuthorChange(e.target.value)}
          className="form-input"
          placeholder="Lois Lowry"
        />
      </div>

      <div className="form-group">
        <label htmlFor="grade-level">Grade Level</label>
        <select
          id="grade-level"
          value={gradeLevel}
          onChange={(e: React.ChangeEvent<HTMLSelectElement>) => onGradeLevelChange(e.target.value)}
          className="form-select"
        >
          {GRADE_LEVELS.map((g) => (
            <option key={g} value={g}>
              {g}
            </option>
          ))}
        </select>
      </div>

      <div className="form-group">
        <label htmlFor="subject">Subject</label>
        <select
          id="subject"
          value={subject}
          onChange={(e: React.ChangeEvent<HTMLSelectElement>) => onSubjectChange(e.target.value)}
          className="form-select"
        >
          {SUBJECTS.map((s) => (
            <option key={s} value={s}>
              {s}
            </option>
          ))}
        </select>
      </div>

      <div className="form-group">
        <label htmlFor="word-count">Number of Words</label>
        <select
          id="word-count"
          value={wordCount}
          onChange={(e: React.ChangeEvent<HTMLSelectElement>) => onWordCountChange(Number(e.target.value))}
          className="form-select"
        >
          {[10, 15, 20, 25, 30].map((n) => (
            <option key={n} value={n}>
              {n} words
            </option>
          ))}
        </select>
      </div>
    </div>
  );
}
